import React, { useEffect } from "react";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

const CongratulationsVideo = () => {
  useEffect(() => {
    Fancybox.show([
      {
        src: "https://www.youtube.com/watch?v=1EQYH1KL5Dc?autoplay=1&mute=1",
        type: "iframe",
      },
    ]);
  }, []);
  return (
    <></>
  );
};

export default CongratulationsVideo;